<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-black ml-1">
          Tubtim Ticket
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Welcome to Tubtim Ticket
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to access Admin Configurations
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Username or Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username or Email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="username or john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Sign in
              </b-button>
              <b-button
                type="button"
                variant="primary"
                block
                @click="signInWithCxOne()"
              >
                Sign in with CXONE
              </b-button>
              <b-button
                type="button"
                variant="primary"
                block
                @click="signInWithSSO()"
              >
                Sign in with Tubtim SSO
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { CXONE_CONFIG, POPUP_CONFIG } from '@/constants/cxone'
import { getCXOneMessageType } from '@/utils/cxoneAuthMessage'
import { showErrorToast, showWarningToast } from '@/utils/toast'
import { Logger } from '@/utils/logger'

const loginLogger = Logger.create('Login')

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [togglePasswordVisibility],
  data () {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg')
    }
  },
  computed: {
    passwordToggleIcon () {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl () {
      return store.state.appConfig.layout.skin === 'dark'
        ? require('@/assets/images/pages/login-v2-dark.svg')
        : require('@/assets/images/pages/login-v2.svg')
    },
    ...mapGetters({
      profile: 'User/user'
    })
  },
  mounted () {
    if (this.profile) {
      this.$router.push('/')
    }
    // Listen for auth success from popup
    window.addEventListener('message', this.handleAuthMessage)
  },
  beforeDestroy () {
    // Remove event listener
    window.removeEventListener('message', this.handleAuthMessage)
  },
  methods: {
    // --- Form login ---
    ...mapActions({
      signIn: 'User/signIn'
    }),
    async validationForm () {
      try {
        const validate = await this.$refs.loginValidation.validate()
        if (validate) {
          await this.signIn({ username: this.userEmail, password: this.password })
          this.$store.dispatch('User/setCXONELogin', { isLogin: false })
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Login Success',
              icon: 'EditIcon',
              variant: 'success'
            }
          })
          this.$router.go(0)
        }
      } catch (err) {
        showErrorToast(this, err.message || 'Login Failed', err.message)
      }
    },

    // --- CXOne (popup) ---
    /**
     * Initiates CXOne OAuth authentication flow (opens popup).
     */
    signInWithCxOne () {
      const clientId = CXONE_CONFIG.CLIENT_ID
      if (!clientId) {
        showErrorToast(this, 'Configuration Error', 'CXOne Client ID is not configured')
        return
      }
      
      // ใช้ window.location.origin เพื่อให้ได้ port ที่ถูกต้องตามที่ user เปิดอยู่
      const baseUrl = window.location.origin
      const redirectUri = `${baseUrl}/cxone/auth`
      const authUrl = `${CXONE_CONFIG.AUTH_URL}?scope=${CXONE_CONFIG.SCOPE}&client_id=${clientId}&response_type=${CXONE_CONFIG.RESPONSE_TYPE}&redirect_uri=${encodeURIComponent(redirectUri)}`
      
      // เปิด popup window แทน redirect
      const popup = window.open(
        authUrl,
        'CXOneAuth',
        POPUP_CONFIG.FEATURES
      )
      
      // เช็คว่า popup ถูก block หรือไม่
      if (!popup || popup.closed) {
        showWarningToast(
          this,
          'Popup Blocked',
          'Please allow popups for this website to login with CXone'
        )
      }
    },

    // --- Tubtim SSO ---
    /**
     * Initiate SSO sign-in flow with TubtimAuth.
     * Redirects to BRS API SSO start endpoint.
     */
    signInWithSSO () {
      const apiBaseUrl = process.env.VUE_APP_API_URL
      if (!apiBaseUrl) {
        showErrorToast(this, 'Configuration Error', 'API URL is not configured')
        return
      }
      window.location.href = `${apiBaseUrl}/auth/sso/tubtim/start`
    },

    /**
     * Handle postMessage from CXOne popup (origin-checked via getCXOneMessageType).
     */
    handleAuthMessage (event) {
      const currentOrigin = window.location.origin
      const messageType = getCXOneMessageType(event, currentOrigin)

      if (messageType === 'success') {
        loginLogger.info('Received auth success from popup, applying session to parent store...')
        this.$store.dispatch('User/applyCXOneAuthPayload', event.data)
        loginLogger.info('Redirecting to dashboard...')
        this.$router.push({ name: 'dashboard' })
      } else if (messageType === 'error') {
        loginLogger.error('Auth error from popup:', event.data?.error)
        showErrorToast(this, 'Login Failed', event.data?.error || 'Authentication failed')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
